export const getItemWhere = (array, key, value) => {
	return array.find((item) => {
		return item[key] ? item[key] === value : false;
	});
};

export const getIndexWhere = (array, key, value) => {
	return array.findIndex((item) => {
		return item[key] ? item[key] === value : false;
	});
};

export const changeWhere = (array, key, value, newValue) => {
	return array.map((item) => {
		if (item[key] !== value) return item;

		return newValue;
	});
};
